class AnimatedDetails extends HTMLElement {
  constructor() {
    super()

    this.items.forEach((item) => {
      this.setHeight(item)
    })
  }

  connectedCallback() {
    this.heads.forEach((head) => {
      head.addEventListener("click", this.onClick.bind(this))
    })

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", this.onTriggerClick.bind(this))
    })
  }

  onClick(event) {
    const item = event.currentTarget.closest(".js-item")
    if (item) this.toggleItem(item)
  }

  onTriggerClick(event) {
    const itemHandle = event.currentTarget.getAttribute("data-item")
    const relatedItem = this.querySelector(`.js-item[data-item="${itemHandle}"]`)
    if (relatedItem) this.toggleItem(relatedItem, true)
  }

  toggleItem(targetItem, forceOpen = false) {
    this.items.forEach((item) => {
      if (targetItem == item) {
        if (forceOpen) {
          item.classList.add("active")
        } else {
          item.classList.toggle("active")
        }
      } else {
        item.classList.remove("active")
      }
    })

    this.triggers.forEach((trigger) => {
      const itemHandle = trigger.getAttribute("data-item")
      const relatedItem = this.querySelector(`.js-item[data-item="${itemHandle}"]`)
      if (relatedItem?.classList.contains("active")) {
        trigger.classList.add("active")
      } else {
        trigger.classList.remove("active")
      }
    })

    this.setHeight(targetItem)
  }

  setHeight(item) {
    const content = item.querySelector(".js-content")
    if (content) item.style.setProperty("--content-height", `${content.scrollHeight}px`)
  }

  get heads() {
    return this.querySelectorAll(".js-item .js-head")
  }

  get triggers() {
    return this.querySelectorAll(".js-trigger")
  }

  get items() {
    return this.querySelectorAll(".js-item")
  }
}

window.customElements.define("tabs-and-accordions", AnimatedDetails)
